// extracted by mini-css-extract-plugin
module.exports = {"citationsSectionWrapper":"Ldk7F8tx","citationsTitle":"cROJvYDf","documentsWrapper":"LJGwjJDR"};